import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Platform, useQuery } from "@core/api";
import { OrganizationContext } from "@core/organization";
import Registry from "@core/registry";
import { createContext, useContext } from "react";
import { useDispatch } from "react-redux";
import { LicenseActions } from "../actions/LicenseActions.js";
export var LicenseContext = /*#__PURE__*/ createContext({
    query: null
});
export var useLicense = function() {
    var context = useContext(LicenseContext);
    if (!context || !context.query) {
        throw new Error("useLicense must be used within a LicenseProvider");
    }
    if (!context.query.data) {
        throw new Error("License data is not available");
    }
    return context.query.data;
};
export var LicenseProvider = function(param) {
    var children = param.children;
    var ref, ref1, ref2;
    var organizationCtx = useContext(OrganizationContext);
    var orgId = (ref = organizationCtx.organizationModelQuery) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.id;
    var dispatch = useDispatch();
    var licenseQuery = useQuery({
        queryKey: [
            "init",
            "license",
            orgId
        ],
        queryFn: /*#__PURE__*/ _async_to_generator(function() {
            var license;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Platform.licenseInternal.full()
                        ];
                    case 1:
                        license = _state.sent();
                        dispatch(LicenseActions.update(license));
                        Registry.register("license", license);
                        return [
                            2,
                            license
                        ];
                }
            });
        }),
        retry: false,
        enabled: (ref2 = organizationCtx.organizationModelQuery) === null || ref2 === void 0 ? void 0 : ref2.isSuccess,
        initialData: Registry.get("license", {
            optional: true
        }),
        staleTime: Infinity
    });
    return /*#__PURE__*/ _jsx(LicenseContext.Provider, {
        value: {
            query: licenseQuery
        },
        children: children
    });
};

//# sourceMappingURL=LicenseContext.js.map